<template>
  <Marco>
    <div slot="content">
      <div class="main-title">
        <h1 class="title">{{ step.pregunta }}</h1>
      </div>

      <div class="field-row">
        <div class="field">
          <p class="label">{{ step.subPregunta }}</p>
          <div class="wysiwyg">
            <ul class="list-type2" :class="numCols">
              <li
                v-for="respuesta in step.posiblesRespuestas"
                :key="respuesta.id"
              >
                <a
                  v-if="respuesta.id != opcionSelected.id"
                  href="#"
                  @click.prevent="siguiente(respuesta)"
                  class="enlace"
                  >{{ respuesta.descr }}</a
                >
                <a
                  v-if="respuesta.id == opcionSelected.id"
                  href="#"
                  @click.prevent="siguiente(respuesta)"
                  class="seleccion"
                  >{{ respuesta.descr }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="step.infoAdicional" class="wysiwyg">
        <p class="title" style="font-weight:bold">
          {{ step.infoAdicionalTitulo }}
        </p>
        <p class="label">{{ step.infoAdicional }}</p>
      </div>
    </div>

    <a
      v-if="this.$route.params.np"
      slot="botonAtras"
      href="#"
      @click.prevent="$router.go(-1)"
      >Atrás</a
    >
    <a
      v-if="opcionSelected"
      slot="botonSiguiente"
      href="#"
      @click.prevent="siguiente(opcionSelected)"
      >Siguiente</a
    >
  </Marco>
</template>

<script>
import actions from "@/util/actions.js";
export default {
  store: ["step"],

  data() {
    return {
      opcionSelected: "",
      infoAdicionalTitulo: "",
      infoAdiccional: ""
    };
  },

  computed: {
    numCols() {
      return this.step.tipoPantalla == "o" ? "three-cols" : "one-col";
    }
  },

  mounted() {
    let seleccionAnt = actions.getSeleccionAnterior(this.$route.params.np);
    this.opcionSelected = seleccionAnt == null ? "" : seleccionAnt;
  },

  methods: {
    atras: async function() {
      this.$emit("atras");
    },

    siguiente(seleccion) {
      actions.setSeleccion(this.$route.params.np, seleccion);
      this.$emit("elegido", seleccion.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.seleccion {
  color: $naranjaMMT;
  font-weight: 350;
}

.enlace {
  text-decoration: none;
}
.enlace:hover {
  font-weight: bolder;
  color: $naranjaMMT;
  text-decoration: underline;
}
</style>
